import { render } from "./UpdateDataScreen.vue?vue&type=template&id=51bf3137"
import script from "./UpdateDataScreen.vue?vue&type=script&lang=js"
export * from "./UpdateDataScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__